export default __webpack_public_path__ + "static/media/ESSC32LSAP01.5c5a92b3.mp4";